import { chainList } from 'chain-list'
import { WithTooltip } from 'metronome-ui/components/WithTooltip'
import { useChainId } from 'metronome-ui/hooks/chains'
import useTranslation from 'next-translate/useTranslation'
import { useContext } from 'react'

import IconContainer from './icons/IconContainer'
import { MetronomeContext } from './MetronomeContext'
import { CC_SLIPPAGE_DEFAULT, SLIPPAGE_DEFAULT } from './Slippage'

function Routing({
  crossChainDstId,
  disabled,
  isCrossChain,
  setCrossChainDstId,
  setSlippage
}) {
  const { t } = useTranslation()
  const chainId = useChainId()
  const {
    selectedPoolData: {
      status: { isBridgingActive },
      supportedDestinationChainIds
    }
  } = useContext(MetronomeContext)
  const defaultSlippage = !isCrossChain ? CC_SLIPPAGE_DEFAULT : SLIPPAGE_DEFAULT
  const handleOnClick = _chainId =>
    function () {
      setCrossChainDstId(_chainId)
      setSlippage(defaultSlippage)
    }

  return process.env.NEXT_PUBLIC_FLAGS_CROSS_CHAIN === 'true' &&
    isBridgingActive ? (
    <div className="my-6">
      <div className="mb-4 flex items-center space-x-1">
        <span className="font-medium">{t('routing.title')}</span>
        <WithTooltip
          className="ml-2.5 mt-1 text-left"
          overlay={
            <div className="w-80 border-0">
              <p className="mb-2 text-sm text-white">
                {t('routing.tooltip.title')}
              </p>
              <p className="text-xs text-gray-600">
                {t('routing.tooltip.description')}
              </p>
            </div>
          }
        >
          <IconContainer name="exclamationmark" />
        </WithTooltip>
      </div>
      <div className="space-x-4">
        {chainList
          .sort(chain => (chain.chainId === chainId ? -1 : 1))
          .filter(
            chain =>
              supportedDestinationChainIds.includes(chain.chainId) ||
              chain.chainId === chainId
          )
          .map(chain => (
            <button
              className={`inline-flex grow-0 cursor-pointer items-center space-x-1 rounded p-2
                ${crossChainDstId === chain.chainId && 'bg-blue-5'}
                ${disabled ? 'opacity-50' : ''}`}
              disabled={disabled}
              key={chain.chainId}
              onClick={handleOnClick(chain.chainId)}
              type="button"
            >
              <IconContainer name={chain.shortName} />
              <span>{chain.name}</span>
            </button>
          ))}
      </div>
    </div>
  ) : null
}

export default Routing
